// import { AdminQuestionSystem } from "../../Components/AdminQuestionSystem";
// import { AdminRuleSystem } from "../../Components/AdminRuleSystem";
// import { AdminUserSystem } from "../../Components/AdminUserSystem";
// import PPRCategoriesSystem from "../../Components/PPRCategoriesSystem";
// import StandManagementSystem from "../../Components/StandManagementSystem";
// import { AdminPaymentSystem } from "../../Components/AdminPaymentSystem";
// import { AdminRequestSystem } from "../../Components/AdminRequestSystem";
// import { useEffect, useState } from "react";
// import { Button, Grid, Indicator, rem } from "@mantine/core";
// import { getUserRequestCountAdmin } from "../../misc/api";
// import AdminInvoiceScreen from "../../Components/AdminInvoiceSystem";

// const ADMIN_SCREENS = {
//   requests: {
//     component: AdminRequestSystem,
//     title: "Flight Requests Management",
//     route: "/admin-requests",
//     button: {
//       label: "Pieprasījumu pārvaldība",
//       gradient: { from: "orange", to: "red" },
//       withIndicator: true,
//     },
//   },
//   questions: {
//     component: AdminQuestionSystem,
//     title: "Questions Management",
//     route: "/admin-questions",
//     button: {
//       label: "Apstrādāt jautājumus",
//       gradient: { from: "teal", to: "lime", deg: 105 },
//     },
//   },
//   rules: {
//     component: AdminRuleSystem,
//     title: "Rules Management",
//     route: "/admin-rules",
//     button: {
//       label: "Apstrādāt likumus",
//       gradient: { from: "indigo", to: "cyan" },
//     },
//   },
//   users: {
//     component: AdminUserSystem,
//     title: "User Management",
//     route: "/admin-users",
//     button: {
//       label: "Lietotāju pārvaldība",
//       gradient: { from: "teal", to: "blue", deg: 60 },
//     },
//   },
//   payments: {
//     component: AdminPaymentSystem,
//     title: null,
//     route: "/admin-payments",
//     button: {
//       label: "Cenu pārvaldība",
//       gradient: { from: "#ed6ea0", to: "#ec8c69", deg: 35 },
//     },
//   },
//   // invoices: {
//   //   component: AdminInvoiceScreen,
//   //   title: "Invoices",
//   //   route: "/admin-invoices",
//   //   button: {
//   //     label: "Rēķini",
//   //     gradient: { from: "pink", to: "red", deg: 105 },
//   //   },
//   // },
//   "ppr-categories": {
//     component: PPRCategoriesSystem,
//     title: "PPR Categories Management",
//     route: "/admin-ppr-categories",
//     button: {
//       label: "PPR kategorijas",
//       gradient: { from: "#ff0000", to: "#0000ff90", deg: 35 },
//     },
//   },
//   stands: {
//     component: StandManagementSystem,
//     title: "Stand Management",
//     route: "/admin-stands",
//     button: {
//       label: "Stāvvietas",
//       gradient: { from: "#00ff0090", to: "#8080ff", deg: 35 },
//     },
//   },
// };

// export const GenericAdminScreen = ({ type }) => {
//   const screenConfig = ADMIN_SCREENS[type];
//   const [request, setRequest] = useState(null);

//   useEffect(() => {
//     if (!screenConfig) {
//       getUserRequestCountAdmin().then(setRequest);
//     }
//   }, [screenConfig]);

//   if (!screenConfig) {
//     return (
//       <>
//         <Grid style={{ marginTop: 40 }}>
//           {Object.entries(ADMIN_SCREENS).map(([key, { route, button }]) => (
//             <Grid.Col
//               key={key}
//               span={{ xs: 4 }}
//               style={{ padding: 15, minHeight: rem(50) }}
//             >
//               {button.withIndicator ? (
//                 <Indicator
//                   inline
//                   label={request?.data?.pending_requests}
//                   size={request?.data?.pending_requests > 0 ? 16 : 0}
//                   style={{ width: "100%" }}
//                 >
//                   <Button
//                     variant="gradient"
//                     style={{ width: "100%" }}
//                     gradient={button.gradient}
//                     onClick={() => (window.location.href = route)}
//                   >
//                     {button.label}
//                   </Button>
//                 </Indicator>
//               ) : (
//                 <Button
//                   variant="gradient"
//                   style={{ width: "100%" }}
//                   gradient={button.gradient}
//                   onClick={() => (window.location.href = route)}
//                 >
//                   {button.label}
//                 </Button>
//               )}
//             </Grid.Col>
//           ))}
//         </Grid>
//       </>
//     );
//   }

//   const ComponentToRender = screenConfig.component;

//   return (
//     <>
//       <div style={{ marginBottom: "20px" }}>
//         <h2>{screenConfig.title}</h2>
//       </div>
//       <ComponentToRender />
//     </>
//   );
// };

import { AdminQuestionSystem } from "../../Components/AdminQuestionSystem";
import { AdminRuleSystem } from "../../Components/AdminRuleSystem";
import { AdminUserSystem } from "../../Components/AdminUserSystem";
import PPRCategoriesSystem from "../../Components/PPRCategoriesSystem";
import StandManagementSystem from "../../Components/StandManagementSystem";
import { AdminPaymentSystem } from "../../Components/AdminPaymentSystem";
import { AdminRequestSystem } from "../../Components/AdminRequestSystem";
import { useEffect, useState } from "react";
import { Button, Grid, Indicator, rem } from "@mantine/core";
import { getUserRequestCountAdmin } from "../../misc/api";
import AdminInvoiceScreen from "../../Components/AdminInvoiceSystem";
import { getGroup } from "../../misc/tokens";

// Dežurants permissions - toggle features here
const DEZURANTS_PERMISSIONS = {
  CAN_EDIT_PAYMENTS: false, // Set to true when confirmed
};

const ADMIN_SCREENS = {
  requests: {
    component: AdminRequestSystem,
    title: "Flight Requests Management",
    route: "/admin-requests",
    button: {
      label: "Pieprasījumu pārvaldība",
      gradient: { from: "orange", to: "red" },
      withIndicator: true,
    },
    allowedGroups: ["0", "100"], // Admin and Dežurants
  },
  questions: {
    component: AdminQuestionSystem,
    title: "Questions Management",
    route: "/admin-questions",
    button: {
      label: "Apstrādāt jautājumus",
      gradient: { from: "teal", to: "lime", deg: 105 },
    },
    allowedGroups: ["0"], // Admin only
  },
  rules: {
    component: AdminRuleSystem,
    title: "Rules Management",
    route: "/admin-rules",
    button: {
      label: "Apstrādāt likumus",
      gradient: { from: "indigo", to: "cyan" },
    },
    allowedGroups: ["0"], // Admin only
  },
  users: {
    component: AdminUserSystem,
    title: "User Management",
    route: "/admin-users",
    button: {
      label: "Lietotāju pārvaldība",
      gradient: { from: "teal", to: "blue", deg: 60 },
    },
    allowedGroups: ["0"], // Admin only
  },
  payments: {
    component: AdminPaymentSystem,
    title: null,
    route: "/admin-payments",
    button: {
      label: "Cenu pārvaldība",
      gradient: { from: "#ed6ea0", to: "#ec8c69", deg: 35 },
    },
    allowedGroups: ["0", "100"], // Dežurants can view, CAN_EDIT_PAYMENTS controls editing
  },
  "ppr-categories": {
    component: PPRCategoriesSystem,
    title: "PPR Categories Management",
    route: "/admin-ppr-categories",
    button: {
      label: "PPR kategorijas",
      gradient: { from: "#ff0000", to: "#0000ff90", deg: 35 },
    },
    allowedGroups: ["0"], // Admin only
  },
  stands: {
    component: StandManagementSystem,
    title: "Stand Management",
    route: "/admin-stands",
    button: {
      label: "Stāvvietas",
      gradient: { from: "#00ff0090", to: "#8080ff", deg: 35 },
    },
    allowedGroups: ["0"], // Admin only
  },
};

export const GenericAdminScreen = ({ type }) => {
  const screenConfig = ADMIN_SCREENS[type];
  const [request, setRequest] = useState(null);
  const group = getGroup();

  useEffect(() => {
    if (!screenConfig) {
      getUserRequestCountAdmin().then(setRequest);
    }
  }, [screenConfig]);

  // Filter screens based on user group
  const visibleScreens = Object.entries(ADMIN_SCREENS).filter(
    ([key, config]) => config.allowedGroups.includes(group)
  );

  if (!screenConfig) {
    return (
      <>
        <Grid style={{ marginTop: 40 }}>
          {visibleScreens.map(([key, { route, button }]) => (
            <Grid.Col
              key={key}
              span={{ xs: 4 }}
              style={{ padding: 15, minHeight: rem(50) }}
            >
              {button.withIndicator ? (
                <Indicator
                  inline
                  label={request?.data?.pending_requests}
                  size={request?.data?.pending_requests > 0 ? 16 : 0}
                  style={{ width: "100%" }}
                >
                  <Button
                    variant="gradient"
                    style={{ width: "100%" }}
                    gradient={button.gradient}
                    onClick={() => (window.location.href = route)}
                  >
                    {button.label}
                  </Button>
                </Indicator>
              ) : (
                <Button
                  variant="gradient"
                  style={{ width: "100%" }}
                  gradient={button.gradient}
                  onClick={() => (window.location.href = route)}
                >
                  {button.label}
                </Button>
              )}
            </Grid.Col>
          ))}
        </Grid>
      </>
    );
  }

  // Check if user has access to this specific screen
  if (!screenConfig.allowedGroups.includes(group)) {
    return <div>Access denied</div>;
  }

  const ComponentToRender = screenConfig.component;

  return (
    <>
      <div style={{ marginBottom: "20px" }}>
        <h2>{screenConfig.title}</h2>
      </div>
      <ComponentToRender />
    </>
  );
};